export default [
  { value: 0, label: 'CAR' },
  { value: 1, label: 'MOTORCYCLE' },
  { value: 2, label: 'TRUCK' },
  { value: 3, label: 'BUS' },
];
